export function progressionContext(transaction) {
    return {
        get: (resource) => transaction.get(resource),
        getAllocation: (allocation, targetId) => transaction.getAllocation(allocation.id, targetId),
        hasUpgrade: (id) => transaction.hasProgress("upgrade", id),
        hasMilestone: (id) => transaction.hasProgress("milestone", id),
        hasAchievement: (id) => transaction.hasProgress("achievement", id),
        isChallengeActive: (id) => transaction.isChallengeActive(id),
        challengeCompletions: (id) => transaction.getChallengeCompletions(id),
        purchaseCount: (id) => transaction.getPurchase(id),
    };
}
//# sourceMappingURL=context.js.map